<template>
    <div class="print-table-body__content">

        <div :key="`${$index}-content`" v-for="(item, $index) in dataList" class="print-table-body__content__item"> 
            <div :class="itemWidth[0].type">
                <span>{{item.componentCode}}</span><br>
                <span>{{item.componentDesc}}</span>
            </div>
            <div v-if="type === 'ACE'" :class="itemWidth[1].type">
                <span>
                    {{item.type}}
                </span>
            </div>
            <div class="table__practicalSealingWidth" :class="itemWidth[2].type">
                <span >{{item.practicalSealingWidth}}</span>
            </div>
            <div class="table__componentUsage" :class="itemWidth[3].type">
                <span >
                    {{item.componentUsage}}{{item.unitCode}}
                </span>
            </div>
            <div v-if="brand == '6'" class="table__dosage" :class="itemWidth[4].type">
                <span >
                    {{item.europeOrderComponentUsage}}{{item.unitCode}}
                </span>
            </div>
            <div class="table__usedPosition" :class="itemWidth[5].type">
                <span >
                    {{item.usedPosition}}
                </span>
            </div>
            <div class="table__remark" :class="itemWidth[6].type">
                <span > 
                    {{item.remark}}
                </span>
            </div>
            <div 
                class="table__input"
                v-for="(inner, $innIndex) in item.colorList"
                :key="`${$innIndex}-inner-td`">
                    <div class="table__input__box" style="display: flex;justify-content: center;align-items: flex-start;width: 100%;height: 100%;">
                        <template v-if="inner && item.colorMap[inner]">
                            <input v-if="item.colorMap[inner] == '1'" type="checkbox" checked/>
                            <input v-else-if="item.colorMap[inner] == '0'" type="checkbox"/>
                            <span v-else>{{item.colorMap[inner]}}</span>
                        </template>
                        <template v-else-if="inner && !item.colorMap[inner]">
                            
                        </template>

                    </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {JsonDeepCopy} from 'src/store/utils';
    import {titleRule, setWdith, tableHeadConfig, tableHeadConfigACE} from './widthRule';
    import {strlen, subString, toFixed} from 'src/store/utils';
    // import SelectInput from "src/components/form/SelectInput.vue";
    // import SingleCheckBoxInput from "src/components/form/SingleCheckBoxInput.vue";

    export default {
        name: 'table-body-content',
        components: {
            // "s-input": SelectInput,
            // "sc-input": SingleCheckBoxInput
        },
        props: {
            materialColorMapList: {
                type: Array,
                default: () => ([])
            },
            sourceList: {
                type: Array,
                defalut: () => ([])
            },
            type: {
                type: String,
                default: 'ACE'
            },
            brand: {
                type: String,
            },
            tableRowNum: {
                type: Object
            }
        },
        filters: {
            subText(val) {
                const MAX = 64;
                if (strlen(val) > MAX) return subString(val, MAX);
                return val
            }
        },
        computed: {
            o_enums: function(){
                return this.$store.getters.o_enums;
            },
            itemWidth() {
                return tableHeadConfigACE
            },
            dataList() {
                let _this = this
                let brands = this.brand
                let list = JsonDeepCopy(this.materialColorMapList);
                const apgeType = this.type;
                const length = list.length;
                let data = JsonDeepCopy(this.sourceList);
                const o_enums = this.o_enums;
                const tableRowNum = this.tableRowNum;
                data = formatData(data, list.length);
                console.log('data:', data)

                return data;
                // @params data 数据
                // ACE length <= 4 纵向打印 8行 >4 横向打印 5行
                // BD length <= 4 纵向打印 16行 >4 横向打印 8行
                function formatData(data) {
                    let array = [];
                    array = data.map(item => ({
                        componentCode: item.code,
                        componentDesc: item.name,
                        // type: item.componentType != null?o_enums['BOMComponentType'][item.componentType].valueDesc:'',
                        type: item.type,
                        practicalSealingWidth:  item.standardCode,// apgeType === 'ACE'?item.practicalSealingWidth:item.standard,
                        // componentUsage:!(item.makermakingStatus == 0 && apgeType === 'ACE')? (item.componentUsage?toFixed(item.componentUsage, 3) + item.unitCode:''):'',
                        componentUsage: item.pieceNetUsage,
                        usedPosition: item.usedPosition,
                        remark: item.remark,
                        colorList: colorList(_this.materialColorMapList),
                        // hasInput: item.colorOptions != null?item.colorOptions.length > 0: false,
                        bomItem: item,
                        source: item,
                        bomType: item.bomType,
                        colorMap: item.colorMap,
                        unitCode: item.unitCode ? '/' + item.unitCode : '',
                        europeOrderComponentUsage: item.europeOrderComponentUsage
                    }))

                    if (length <= 4 && data.length < tableRowNum.vertical) {
                        for(let i = 0;  i < tableRowNum.vertical - data.length; i++) {
                            array.push({colorList: ['','','','']})
                        }
                    }
                    else if (length > 4 && data.length < tableRowNum.horizontal){
                        for(let i = 0;  i < tableRowNum.horizontal - data.length; i++) {
                            array.push({colorList: ['', '', '', '', '', '', '']})
                        }
                    }
                    return array;
                };

                function colorList(list) {
                    let array = [];
                    if (list.length > 0) {
                        array = list.map(item => item.colorName);
                        if (list.length <= 4) {
                            for(let i = 0; i < 4 - list.length; i++) {
                                array.push('')
                            }
                        } else {
                            for(let i = 0; i < 7 - list.length; i++) {
                                array.push('')
                            }
                        }
                    } else {
                        array = ['','','','']
                    }
                    return array;
                };
            }
        },
        data() {
            return {
                check: true
            }
        },
        mounted() {
            console.log(this.dataList)
        }
    }
</script>